import { Alert, Button } from "@mui/material";
import { useStaleBuild } from "../api/build-version";

export const NewVersionBanner: React.FC = () => {
	const stale = useStaleBuild();
	if (!stale) return null;

	return (
		<Alert
			severity="warning"
			data-component="new-version-banner"
			action={
				<Button
					color="inherit"
					size="small"
					onClick={() => window.location.reload()}
					data-component="new-version-reload-button"
				>
					Reload
				</Button>
			}
		>
			A new version of the app is available. Reload when convenient to apply it.
		</Alert>
	);
};
